import { createSlice } from "@reduxjs/toolkit";
import { resetALL } from "Redux/actions";

//STATE INITIAL
const INIT_STATE = {
    loading: false
};


//Slice
const chatMessageListRedux = createSlice({
    name: 'chat/messageList',
    initialState: INIT_STATE,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        reset() {
            return INIT_STATE;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);
    }
});

// Export actions
export const { setLoading, reset } = chatMessageListRedux.actions;

// Export the reducer
export default chatMessageListRedux.reducer;
